import { COMPANY_INFO } from "../data/companyData";

export default function FloatingCTA() {
  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-6 right-5 sm:bottom-8 sm:right-8 z-40 flex flex-col items-end gap-3 pointer-events-none"
    >
      {/* Phone Floating Button */}
      <a
        href={`tel:${COMPANY_INFO.phoneRaw}`}
        aria-label={`Ring til os på ${COMPANY_INFO.phone}`}
        title={`Ring til os på ${COMPANY_INFO.phone}`}
        className="pointer-events-auto group relative w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#ce0611] text-white hover:bg-[#b0040e] shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 ease-in-out hover:scale-110 hover:-translate-y-1 active:scale-95 focus:outline-none focus:ring-4 focus:ring-red-500/30"
      >
        <i className="fa-solid fa-phone text-lg sm:text-xl transition-transform duration-300 group-hover:rotate-12" aria-hidden="true" />
      </a>

      {/* Email Floating Button */}
      <a
        href={`mailto:${COMPANY_INFO.email}`}
        aria-label={`Send en e-mail til ${COMPANY_INFO.email}`}
        title={`Send en e-mail til ${COMPANY_INFO.email}`}
        className="pointer-events-auto group relative w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-stone-900 text-white hover:bg-stone-800 shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 ease-in-out hover:scale-110 hover:-translate-y-1 active:scale-95 focus:outline-none focus:ring-4 focus:ring-stone-500/30 border border-stone-700/40"
      >
        <i className="fa-solid fa-envelope text-lg sm:text-xl transition-transform duration-300 group-hover:scale-110" aria-hidden="true" />
      </a>
    </aside>
  );
}
